<div class="mockup ipad">
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
